<template>
  <div id="challenges">
    <div
      id="content"
      class="content"
    >
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-swords"></i>
          Défis
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message type="is-primary">
          <i class="fal fa-info-circle"></i>
          Retrouvez ici la liste de vos défis passés, en attente d'acceptation et à relever
          <br>
          Si vous ou une équipe que vous défiez relève un défi, les autres défis en attente qui vous/lui sont liés seront effacés
        </b-message>
      </div>
      <div
        v-if="!isAdmin && in_progress_challenges.length == 0"
        style="margin-top: 10px; text-align: center"
      >
        <button
          class="button is-success is-medium"
          id="clear"
          @click="isComponentModalActive = true"
        >
          <span><i class="fal fa-swords"></i> Défier une Équipe</span>
        </button>
      </div>
      <inProgressChallenges
        v-if="in_progress_challenges.length > 0"
        id="leader-board"
        :in_progress_challenges="in_progress_challenges"
        :weezys="weezys"
      />
      <waitingChallenges
        id="leader-board"
        v-if="(!isAdmin && in_progress_challenges.length == 0 && waiting_challenges.length > 0) || isAdmin"
        :waiting_challenges="waiting_challenges"
        :weezys="weezys"
        :isAdmin="isAdmin"
      />
      <toAcceptChallenges
        v-if="!isAdmin && to_accept_challenges.length > 0 && in_progress_challenges.length == 0"
        id="leader-board"
        :to_accept_challenges="to_accept_challenges"
        :weezys="weezys"
      />
      <finishedChallenges
        id="leader-board"
        :finished_challenges="finished_challenges"
        :weezys="weezys"
      />
    </div>
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
    >
      <form action="new-challenge">
        <div
          class="modal-card"
          style="width: 750px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Défier une Équipe</p>
          </header>
          <section class="modal-card-body">
            <div class="modal-line">
              <b-field
                label="Équipe à défier"
                required
              >
                <b-select
                  placeholder="Choisir l'équipe à défier"
                  v-model="challenged_id"
                  :required="true"
                >
                  <option
                    v-for="weezy in challengible_weezys"
                    :key="weezy.id"
                    :value="weezy.id"
                  >{{weezy.name}}</option>
                </b-select>
              </b-field>
            </div>
          </section>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="submitFormData"
            ><span><i class="fal fa-check"></i> Défier</span></button>
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import waitingChallenges from "@/components/waitingChallenges";
import toAcceptChallenges from "@/components/toAcceptChallenges";
import inProgressChallenges from "@/components/inProgressChallenges";
import finishedChallenges from "@/components/finishedChallenges";

import http from "@/modules/request";

export default {
  name: "weezys",
  components: {
    waitingChallenges,
    toAcceptChallenges,
    inProgressChallenges,
    finishedChallenges
  },
  data() {
    return {
      isAddDisplayed: false,
      isComponentModalActive: false,
      isAdmin: false,
      challenges: {},
      weezys: [],
      waiting_challenges: [],
      to_accept_challenges: [],
      in_progress_challenges: [],
      finished_challenges: [],
      not_challengible_weezys: [],
      challenged_id: undefined,
      creation: undefined
    };
  },

  computed: {
    // Weezys with goals for selected GoalDate
    challengible_weezys: function() {
      return _.pickBy(
        this.weezys,
        function(u) {
          return (
            !this.not_challengible_weezys.includes(u.id) &&
            u.id != this.$store.state.weezy_id
          );
        }.bind(this)
      );
    }
  },

  mounted() {
    clearInterval(this.creation);
    this.isAdmin = this.$store.state.role == "admin";
    this.getWeezys().then(_ => {
      this.getChallenges();
    });
    this.refreshData();
  },
  beforeDestroy() {
    clearInterval(this.creation);
  },
  methods: {
    getWeezys() {
      return new Promise((resolve, reject) => {
        http
          .get("/allWeezys")
          .then(response => {
            this.weezys = response.data;
            resolve();
          })
          .catch(error => {
            console.log(error);
            this.errored = true;
          });
      });
    },

    getChallenges() {
      this.waiting_challenges = [];
      this.to_accept_challenges = [];
      this.in_progress_challenges = [];
      this.finished_challenges = [];
      http
        .get("/privatechallenges")
        .then(response => {
          let tmpChallenges = response.data;
          if (!this.isAdmin) {
            for (let chall of tmpChallenges) {
              //  Get challenge my team has sent
              if (
                chall.weezy1_id == this.$store.state.weezy_id &&
                !chall.is_accepted &&
                !chall.is_rejected
              ) {
                this.waiting_challenges.push(chall);
              }
              // Get challenges waiting for me
              if (
                chall.weezy2_id == this.$store.state.weezy_id &&
                !chall.is_accepted &&
                !chall.is_rejected
              ) {
                this.to_accept_challenges.push(chall);
              }
              // Get challenges in progress
              if (
                (chall.weezy1_id == this.$store.state.weezy_id ||
                  chall.weezy2_id == this.$store.state.weezy_id) &&
                chall.is_active
              ) {
                this.in_progress_challenges.push(chall);
                // If a challenge is in progress, then the weezy cannot be challenged :
                this.not_challengible_weezys.push(chall.weezy1_id);
                this.not_challengible_weezys.push(chall.weezy2_id);
              }
              // Get challenges finished
              if (
                (chall.weezy1_id == this.$store.state.weezy_id ||
                  chall.weezy2_id == this.$store.state.weezy_id) &&
                chall.is_finished &&
                !chall.is_active
              ) {
                this.finished_challenges.push(chall);
              }
            }
          } else {
            for (let chall of tmpChallenges) {
              // ALL Pending challenges
              if (!chall.is_accepted && !chall.is_rejected) {
                this.waiting_challenges.push(chall);
              }
              // All current challenges
              if (chall.is_active) {
                this.in_progress_challenges.push(chall);
              }
              // All finished challenges
              if (chall.is_finished && !chall.is_active) {
                this.finished_challenges.push(chall);
              }
            }
          }
          this.waiting_challenges.sort((a, b) => b.id - a.id);
          this.to_accept_challenges.sort((a, b) => b.id - a.id);
          this.in_progress_challenges.sort((a, b) => b.id - a.id);
          this.finished_challenges.sort((a, b) => b.id - a.id);
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    refreshData() {
      this.creation = setInterval(() => {
        this.getWeezys().then(_ => {
          this.getChallenges();
        });
      }, 90000);
    },
    submitFormData() {
      http
        .post("/challenges", {
          challenge: {
            weezy1_id: this.$store.state.weezy_id,
            weezy2_id: this.challenged_id
          }
        })
        .then(
          function(response) {
            this.succesToast("Équipe défiée avec succès");
            this.getChallenges();
            this.dismissForm();
          }.bind(this)
        )
        .catch(function(error) {
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
          this.errorToast("Échec de création du défi");
        });
    },
    submitModify: function() {
      if (this.is_active && this.campaign_id == null) {
        this.warningToast(
          'Une Campagne est nécessaire pour activer le Weezy : "' +
            this.name +
            '"'
        );
        // this.getWeezys();
      } else {
        http
          .patch("/weezys/" + this.weezyId, {
            weezy: {
              name: this.name,
              campaign_id: this.campaign_id,
              is_active: this.is_active,
              ip_address: this.ip_address,
              supervisor_id: this.supervisor_id,
              stripe_id: this.stripe_id,
              password: this.password
            }
          })
          .then(
            function(response) {
              this.succesToast("Weezy(s) modifié(s) avec succès");
              // this.getWeezys();
            }.bind(this)
          )
          .catch(function(error) {
            this.errorToast("Échec de modification");
            // this.getWeezys();
            console.log("error (normal) :" + error);
            console.log("error (as JSON) :" + JSON.stringify(error));
          });
      }
    },
    modifyRows(rows) {
      var count = rows.length;
      var modifiedArray = [];
      // From latest to oldest
      for (var i = 0; i < count; i++) {
        var modified = rows[count - i - 1];
        if (!modifiedArray.includes(modified.id)) {
          modifiedArray.push(modified.id);
          this.weezyId = modified.id;
          this.name = modified.name;
          this.campaign_id = modified.campaign_id;
          this.ip_address = modified.ip_address;
          this.is_active = modified.is_active;
          this.supervisor_id = modified.supervisor_id;
          this.stripe_id = modified.stripe_id;
          this.password = modified.password;
          this.submitModify();
        }
      }
    },
    errorToast(message) {
      this.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    },
    warningToast(message) {
      this.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-warning"
      });
    },
    dismissForm() {
      this.challenged_id = undefined;
      this.isComponentModalActive = false;
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}
.add-weezy {
  width: auto;
  padding-top: 40px;
  padding-left: 30px;
}
</style>